import '@wellread/tokens/tokens.css';
import './styles/app.css';

import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { persister, queryClient, volatileKeys } from './lib/api';
import { watchOrigin } from './lib/origin';
import { watchSession } from './lib/session';
import { router } from './router';

// A token the API turns down is refreshed once; if that fails, the reader signs in again.
watchSession();
// The reader's back control names the screen it was opened from.
watchOrigin(router);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PersistQueryClientProvider
      client={queryClient}
      // Render from the restored cache at once, then revalidate it: the
      // cache may predate the last write (it persists on a throttle).
      onSuccess={() => {
        void queryClient.resumePausedMutations();
        void queryClient.invalidateQueries({ predicate: (q) => q.queryKey[0] !== 'chapter' });
      }}
      persistOptions={{
        persister,
        maxAge: 7 * 24 * 60 * 60 * 1000,
        // Bump when a cached payload's shape changes, so an old cache is dropped.
        buster: 'v3',
        dehydrateOptions: {
          shouldDehydrateQuery: (q) =>
            q.state.status === 'success' && !volatileKeys.has(String(q.queryKey[0])),
        },
      }}
    >
      <RouterProvider router={router} />
    </PersistQueryClientProvider>
  </StrictMode>,
);
